document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.querySelector('.js-free-contact-search');
    const placesList = document.querySelector('.js-free-contact-places');
    const places = document.querySelectorAll('.js-free-contact-place');
    const noResults = document.querySelector('.js-free-contact-noresults');

    if (!searchInput || !placesList || !places.length || !noResults) {
        return;
    }

    const placesWrapper = placesList.closest('.free-contact__places-wrapper');

    const updateEdgeFade = () => {
        const remaining = placesList.scrollHeight - placesList.scrollTop - placesList.clientHeight;

        placesWrapper?.classList.toggle('is-at-end', remaining <= 8);
    };

    searchInput.addEventListener('input', () => {
        const query = searchInput.value.trim().toLocaleLowerCase('pl-PL');
        let matchedPlaces = 0;

        places.forEach((place) => {
            const isMatch = place.textContent.toLocaleLowerCase('pl-PL').includes(query);

            place.hidden = !isMatch;

            if (isMatch) {
                matchedPlaces += 1;
            }
        });

        noResults.hidden = matchedPlaces > 0;
        placesList.scrollTop = 0;
        updateEdgeFade();
    });

    placesList.addEventListener('scroll', updateEdgeFade, { passive: true });
    updateEdgeFade();
});
